import Vue from 'vue'

export default {
  getRequiredInformation ({ commit }) {
    return Vue.axios.get(`/about/bank-requirements`)
    .then(({ data }) => commit('ADD_REQUIRED_INFORMATION', data))
  },
  addRequiredInformation ({ commit }, data) {
    commit('ADD_NEW_REQUIRED_INFORMATION', data)
  },
  deleteRequiredInformation ({ commit }, id) {
    return Vue.axios.delete(`/about/bank-requirements/${id}`)
    .then(() => commit('DELETE_REQUIRED_INFORMATION', id))
  },
  saveRequiredInformation ({ commit, dispatch }, information) {
    return Vue.axios.put(`/about/bank-requirements/${information.id}`, { information })
    .then(() => {
      if (information.requiredInformationFiles && information.requiredInformationFiles.length) {
        return information.requiredInformationFiles.filter(f => f.newFile).reduce(
          (p, v) => p.then((a) => dispatch('loadRequiredInformationFile', { formData: v.newFile, id: v.id }).then(r => a.concat([r]))),
          Promise.resolve([])
        )
      }

      if (information.requiredInformationBookkeepings && information.requiredInformationBookkeepings.length) {
        return information.requiredInformationBookkeepings.filter(f => f.newFile).reduce(
          (p, v) => p.then((a) => dispatch('loadDisclosureInformationBookkeepinfFile', { formData: v.newFile, id: v.id }).then(r => a.concat([r]))),
          Promise.resolve([])
        )
      }
    })
  },
  updateRequiredInformation ({ commit }, info) {
    commit('UPDATE_REQUIRED_INFORMATION', info)
  },
  addRequiredInformationDocument ({ commit }, data) {
    commit('ADD_REQUIRED_INFORMATION_FILE', data)
  },
  addRequiredBookKeeping ({ commit }, data) {
    commit('ADD_REQUIRED_INFORMATION_BOOKKEERPING', data)
  },
  updateRequiredInformationFile ({ commit }, file) {
    commit('UPDATE_REQUIRED_INFORMATION_FILE', file)
  },
  deleteRequiredInformationFile ({ commit }, file) {
    commit('DELETE_REQUIRED_INFORMATION_FILE', file)
  },
  loadRequiredInformationFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/bank-requirements/files-data/${id}/change-file`, formData)
    .then(({ data }) => commit('CHANGE_REQUIRED_INFORMATION_FILE', data))
  },
  addRequiredInformationRow ({ commit }, data) {
    commit('ADD_REQUIRED_INFORMATION_ROW', data)
  },
  deleteRequiredInformationRow ({ commit }, row) {
    commit('DELETE_REQUIRED_INFORMATION_ROW', row)
  },
  updateRequiredInformationRow ({ commit }, row) {
    commit('UPDATE_REQUIRED_INFORMATION_ROW', row)
  },
  deleteRequiredInformationBookkeeping ({ commit }, row) {
    commit('DELETE_REQUIRED_INFORMATION_BOOKKEEPING', row)
  },
  updateRequiredInformationBookkeeping ({ commit }, row) {
    commit('UPDATE_REQUIRED_INFORMATION_BOOKKEEPEING', row)
  },
  loadDisclosureInformationBookkeepinfFile ({ commit }, { formData, id }) {
    return Vue.axios.post(`/about/bank-requirements/bookkeeping/${id}/change-file`, formData)
    .then(({ data }) => commit('CHANGE_REQUIRED_BOOKKEEPING_FILE', data))
  },
  bankRequirementOrder ({ commit }, requirements) {
    commit('ADD_REQUIRED_INFORMATION', requirements)
    return Vue.axios.put(`/about/bank-requirements/order`, { requirements })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/requiredInformation.js